import { useMemo } from 'react'
import { useQueryHelper } from './useQueryHelper'

type SortOptions = {
  isSingle?: boolean
}

export const useTableSort = () => {
  const queryHelper = useQueryHelper()
  const sortArray = useMemo(() => {
    return queryHelper.query.sort ? queryHelper.query.sort.split(',') : []
  }, [queryHelper.query.sort])

  const ordering = useMemo(() => {
    return sortArray.reduce(
      (acc, v) => {
        if (v.startsWith('-')) {
          acc[v.slice(1)] = 'DESC'
        } else {
          acc[v] = 'ASC'
        }
        return acc
      },
      {} as Record<string, 'ASC' | 'DESC'>,
    )
  }, [sortArray])

  const sort = (key: string, options?: SortOptions) => {
    try {
      const { isSingle = false } = options ?? {}

      const prev = sortArray

      const prevIndex = prev.findIndex((v) => v === key || v === `-${key}`)

      if (prevIndex > -1) {
        if (prevIndex === 0) {
          if (prev[prevIndex] === `-${key}`) {
            prev.splice(prevIndex, 1)
          } else {
            prev[prevIndex] = `-${key}`
          }
        } else {
          const [prevValue] = prev.splice(prevIndex, 1)
          prev.unshift(prevValue)
        }

        queryHelper.replaceQuery({
          sort: prev.join(','),
        })
      } else {
        if (isSingle) {
          queryHelper.replaceQuery({
            sort: key,
          })
        } else {
          queryHelper.replaceQuery({
            sort: [key, ...prev].filter((v) => v).join(','),
          })
        }
      }
    } catch (e) {
      console.log(e)
      queryHelper.replaceQuery({ sort: `-${key}` })
    }
  }

  const removeSort = (key: string) => {
    queryHelper.replaceQuery({
      sort: sortArray.filter((v) => v !== key && v !== `-${key}`).join(','),
    })
  }

  return { sort, removeSort, sortArray, ordering }
}
